import React from 'react'
import { fetchFMProgramsIfNeeded } from '~/programs/actions'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

const NewsIndex = (props) => {
	let shows = {}
	let showImage = {}
	if (props.programsFM.items) {
		shows =  props.programsFM.items.filter(function(item) { if(['Brisbane Line', 'Only Human', 'Eco Radio', "Radio Reversal", 'Paradigm Shift', 'Megaherzzz'].includes(item.name)  ) { return true } else {return false } })
		shows.map( (item ) => {showImage[item.slug] = item } )
	}

	return (
		<div class="info">
			<div>
				<div>
					4ZZZ has been providing independent news and current affairs since its inception in 1975. The newsroom is entirely volunteer based and provides Zedlines bulletins on the hour each weekday from 8-11AM, plus a dedicated one hour news and current-affairs program, Brisbane Line, from 12-1PM on Tuesday, Thursday, and Saturday.
				</div>
			</div>
			<div className="socials">
				<a href="https://facebook.com/4ZZZNews" target="_blank">
					<span className="fa-stack fa-lg">
						<i className="fa fa-square fa-stack-2x"></i>
						<i className="fa fa-facebook fa-stack-1x fa-inverse"></i>
					</span>
				</a>
				<a href="https://twitter.com/4ZZZNews" target="_blank">
					<span className="fa-stack fa-lg">
						<i className="fa fa-square fa-stack-2x"></i>
						<i className="fa fa-twitter fa-stack-1x fa-inverse"></i>
					</span>
				</a>
				<a href="mailto:news-coordinators@4zzz.org.au">
					<span className="fa-stack fa-lg">
						<i className="fa fa-square fa-stack-2x"></i>
						<i className="fa fa-envelope-open fa-stack-1x fa-inverse"></i>
					</span>
				</a>
			</div>
			<div className="news-shows">


			<Link to="/program/brisbane-line"><div>
				<h3>BRISBANE LINE</h3>
				{showImage['brisbane-line'] ? <img src={showImage['brisbane-line'].bannerImageSmall} /> : null }
				<p>4ZZZ's flagship news and current-affairs program.</p>
			</div>
			</Link>
			<Link to="program/only-human"><div>
				<h3>ONLY HUMAN</h3>
				{showImage['only-human'] ? <img src={showImage['only-human'].bannerImageSmall} /> : null }
				<p>Social justice, mental wellbeing and disability rights. </p>
			</div></Link>
			<Link to="/program/eco-radio"><div>
				<h3>ECO RADIO</h3>
				{showImage['eco-radio'] ? <img src={showImage['eco-radio'].bannerImageSmall} /> : null }
				<p>The environment and strategies at the forefront of the move toward sustainability.</p>
			</div></Link>
			<Link to="/program/radio-reversal"><div>
				<h3>RADIO REVERSAL</h3>
				{showImage['radio-reversal'] ? <img src={showImage['radio-reversal'].bannerImageSmall} /> : null }
				<p>Insightful historio-political and theoretical analysis of the everyday.</p>
			</div></Link>
			<Link to="/program/paradigm-shift"><div>
				<h3>PARADIGM SHIFT</h3>
				{showImage['paradigm-shift'] ? <img src={showImage['paradigm-shift'].bannerImageSmall} /> : null }
				<p>News and analysis from Brisbane and around the world, with an emphasis on those trying to create change.</p>
			</div></Link>
			<Link to="/program/megaherzzz"><div>
				<h3>MEGAHERZZZ</h3>
				{showImage['megaherzzz'] ? <img src={showImage['megaherzzz'].bannerImageSmall} /> : null }
				<p>Intersectional feminism and women’s rights.</p>
			</div></Link>
			</div>
		</div>
	)

}
export default connect(state => ({ programsFM: state.programsFM })) (NewsIndex)
